import { FC } from "react";
import BillingFormData from "../types/billing-form.data";
import CardComponent from "../../../../../common/components/card/card.component";
import FormFieldComponent from "../../../../../common/components/form/field/form-field.component";
import NumericInputComponent from "../../../../../common/components/form/input/numeric-input/numeric-input.component";
import Column from "../../../../../common/components/grid/column";
import Row from "../../../../../common/components/grid/row";
import billingsTranslationsHelper from "../../../../../languages/billings-translations.helper";
import BillingFormDataValidationResult from "../types/billing-form-data-validation-result";

type AdditionalOptionsProps = {
  billingData: BillingFormData | undefined;
  onDiscountChanged: (discountValue: number) => void;
  onDiscountBlur: () => void;
  formValidationResults: BillingFormDataValidationResult;
};

const AdditionalOptionsComponent: FC<AdditionalOptionsProps> = (props) => {
  const onDiscountChanged = (discountValue: number | null) => {
    const value = discountValue ?? 0;
    props.onDiscountChanged(value);
  };
  const translations =
    billingsTranslationsHelper.getTaxiRailyAddBillingsTranslations()
      .additionalOptions;
  return (
    <>
      <CardComponent classNames={{ root: "h-100 " }}>
        <Row>
          <Column lg={6}>
            <FormFieldComponent
              errorMessage={
                props.formValidationResults.discountValue.errorMessage
              }
              label={translations.discountLabel}
              classNames={{ root: `mt-0` }}
            >
              <NumericInputComponent
                placeholder=""
                value={props.billingData?.discount ?? null}
                onChange={onDiscountChanged}
                onBlur={props.onDiscountBlur}
                decimalPrecision={2}
                hasError={
                  !!props.formValidationResults.discountValue.errorMessage
                }
              />
            </FormFieldComponent>
          </Column>
        </Row>
      </CardComponent>
    </>
  );
};
export default AdditionalOptionsComponent;
